<template>
  <div style="position: absolute">
    <div class="modal-backdrop fade show"></div>
    <div class="modal plugin-settings-modal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <strong class="modal-title">Project settings</strong>
            <button
              type="button"
              class="close"
              aria-label="Close"
              @click="$emit('close')"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <project-settings :project="project" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import projectSettings from './project-settings.vue'
export default {
  components: { projectSettings },
  name: 'project-settings-popup',
  props: {
    project: Object
  }
}
</script>

<style></style>
